import { render, staticRenderFns } from "./PackageCheckoutModal.vue?vue&type=template&id=05b88652&"
import script from "./PackageCheckoutModal.vue?vue&type=script&lang=js&"
export * from "./PackageCheckoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports